/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
//custom
var pageUrl = $(location).attr("href");
pageUrl = pageUrl.split("?")[1];
$( document ).ready(function() {
  if((pageUrl != undefined) && !(pageUrl.search("Did="))){
    var Did=pageUrl.split("&")[0];
    var Rid=pageUrl.split("&")[1];
    if(pageUrl.search("Rid=") != -1 && pageUrl.search("Did=") != -1){          
      $('.product-form__item--submit').show();
      $('.product-detail').hide();
      $('#add-to-ring').show();
      $('#ring-detail').show();
      $('#choose-setting').hide();
    }
    else if(pageUrl.search("Rid=") != -1){   
      $('.product-form__item--submit').show();
      $('#add-to-ring').hide();
      $('#choose-setting').hide();
      $('.product-detail').hide();
      $('#ring-detail').show();
    }else{
      $('.product-form__item--submit').hide();
      $('.product-detail').hide();
      //$('#ring-detail').hide();
      $('#ring-detail').show();
    }
    $('#diamond-detail').show();
  }else{
    if((pageUrl != undefined) && pageUrl.search("type=") != -1){
      $('#add-to-ring').hide();
    }
    $('.product-form__item--submit').show();
    $('#choose-setting').hide();
    $('.product-detail').show();
    $('#diamond-detail').hide();
    $('#ring-detail').hide();
  }  	
});


//Footer
function footerAdj() {
  var e = $("footer").innerHeight();
  $(".page-wrapper").css({
    "padding-bottom": e
  }), $(".footer-wrapper").css({
    "margin-top": -e
  });
}

$(document).ready(function () {

  $(".hsub-hover > a").click(function() {
    $(this).siblings("ul.sub-menu").slideToggle(), $(this).parents(".hsub-hover").toggleClass("open-sub-menu");
  })
  /*price-slider*/
  if ($("#price").length) {
    var price = document.getElementById('price');

    noUiSlider.create(price, {
      start: [1, 100000],
      connect: true,
      format: wNumb({
        decimals: 0
      }),
      range: {
        'min': 1,
        'max': 100000
      }
    });

    var nodes = [
      document.getElementById('lower-price'),
      document.getElementById('upper-price')
    ];

    price.noUiSlider.on('update', function (values, handle) {
      nodes[handle].value = values[handle];
    });
    nodes.forEach(function (input, handle) {
      input.addEventListener('change', function () {
        price.noUiSlider.setHandle(handle, this.value);
      });
    });
  }
  /*carat-slider*/
  if ($("#carat").length) {
    var carat = document.getElementById('carat');

    noUiSlider.create(carat, {
      start: [0.30, 10.00],
      connect: true,
      format: wNumb({
        decimals: 1
      }),
      range: {
        'min': 0.30,
        'max': 10.00
      }
    });

    var nodes1 = [
      document.getElementById('lower-carat'),
      document.getElementById('upper-carat')
    ];

    carat.noUiSlider.on('update', function (values, handle) {
      nodes1[handle].value = values[handle];
    });
    nodes1.forEach(function (input, handle) {

      input.addEventListener('change', function () {
        carat.noUiSlider.setHandle(handle, this.value);
      });
    });
  }

  /*color-slider*/

  if ($("#color").length) {
    var color = document.getElementById('color');
    var rangeSelector2 = $('#color');
    var pipeMarker2 = rangeSelector2.find(".custom-pipes li")
    pipeMarker2.addClass("selected");
    var pipeMarker2Length = pipeMarker2.length;
    noUiSlider.create(color, {
      range: {
        'min': 1,
        'max': pipeMarker2Length + 1
      },

      step: 1,

      start: [1, pipeMarker2Length + 1],

      margin: 1,

      connect: true,

      orientation: 'horizontal',

      behaviour: 'tap-drag',
      tooltips: false,

      pips: {
        mode: 'steps',
        stepped: true,
        density: pipeMarkerLength + 1
      }
    });

    color.noUiSlider.on('update', function (values, handle) {
      var startPoint2 = parseInt(color.noUiSlider.get()[0]) - 1;
      var endPoint2 = parseInt(color.noUiSlider.get()[1]) - 2;
      pipeMarker2.removeClass("selected");
      for (var i = startPoint2; i <= endPoint2; i++) {
        pipeMarker2.eq(i).addClass("selected");
      }
    });
  }
  /*clarity-slider*/

  if ($("#clarity").length) {
    var clarity = document.getElementById('clarity');
    var rangeSelector1 = $('#clarity');
    var pipeMarker = rangeSelector1.find(".custom-pipes li")
    pipeMarker.addClass("selected");
    var pipeMarkerLength = pipeMarker.length;
    noUiSlider.create(clarity, {
      range: {
        'min': 1,
        'max': pipeMarkerLength + 1
      },

      step: 1,

      start: [1, pipeMarkerLength + 1],

      margin: 1,

      connect: true,

      orientation: 'horizontal',

      behaviour: 'tap-drag',
      tooltips: false,

      pips: {
        mode: 'steps',
        stepped: true,
        density: pipeMarkerLength + 1
      }
    });
    clarity.noUiSlider.on('update', function (values, handle) {
      var startPoint = parseInt(clarity.noUiSlider.get()[0]) - 1;
      var endPoint = parseInt(clarity.noUiSlider.get()[1]) - 2;
      pipeMarker.removeClass("selected");
      for (var i = startPoint; i <= endPoint; i++) {
        pipeMarker.eq(i).addClass("selected");
      }
    });
  }

  /*symmentry-slider*/
  if ($("#symmetry").length) {
    var symmetry = document.getElementById('symmetry');
    var rangeSelector2 = $('#symmetry');
    var pipeMarker3 = rangeSelector2.find(".custom-pipes li")
    pipeMarker3.addClass("selected");
    var pipeMarker3Length = pipeMarker3.length;
    noUiSlider.create(symmetry, {

      range: {
        'min': 1,
        'max': pipeMarker3Length + 1
      },

      step: 1,

      start: [1, pipeMarker3Length + 1],

      margin: 1,

      connect: true,

      orientation: 'horizontal',

      behaviour: 'tap-drag',
      tooltips: false,

      pips: {
        mode: 'steps',
        stepped: true,
        density: pipeMarker3Length + 1
      }
    });
    symmetry.noUiSlider.on('update', function (values, handle) {
      var startPoint3 = parseInt(symmetry.noUiSlider.get()[0]) - 1;
      var endPoint3 = parseInt(symmetry.noUiSlider.get()[1]) - 2;
      pipeMarker3.removeClass("selected");
      for (var i = startPoint3; i <= endPoint3; i++) {
        pipeMarker3.eq(i).addClass("selected");
      }
    });
  }

  /*cut-slider*/
  if ($("#cut").length) {
    var cut = document.getElementById('cut');
    var rangeSelector4 = $('#cut');
    var pipeMarker4 = rangeSelector4.find(".custom-pipes li")
    pipeMarker4.addClass("selected");
    var pipeMarker4Length = pipeMarker4.length;
    noUiSlider.create(cut, {

      range: {
        'min': 1,
        'max': pipeMarker4Length + 1
      },

      step: 1,

      start: [1, pipeMarker4Length + 1],

      margin: 1,

      connect: true,

      orientation: 'horizontal',

      behaviour: 'tap-drag',
      tooltips: false,

      pips: {
        mode: 'steps',
        stepped: true,
        density: pipeMarker4Length + 1
      }
    });
    cut.noUiSlider.on('update', function (values, handle) {
      var startPoint4 = parseInt(cut.noUiSlider.get()[0]) - 1;
      var endPoint4 = parseInt(cut.noUiSlider.get()[1]) - 2;
      pipeMarker4.removeClass("selected");
      for (var i = startPoint4; i <= endPoint4; i++) {
        pipeMarker4.eq(i).addClass("selected");
      }
    });
  }

  /*polish-slider*/
  if ($("#polish").length) {
    var polish = document.getElementById('polish');
    var rangeSelector5 = $('#polish');
    var pipeMarker5 = rangeSelector5.find(".custom-pipes li")
    pipeMarker5.addClass("selected");
    var pipeMarker5Length = pipeMarker5.length;
    noUiSlider.create(polish, {

      range: {
        'min': 1,
        'max': pipeMarker5Length + 1
      },

      step: 1,

      start: [0, pipeMarker5Length + 1],

      margin: 1,

      connect: true,

      orientation: 'horizontal',

      behaviour: 'tap-drag',
      tooltips: false,

      pips: {
        mode: 'steps',
        stepped: true,
        density: pipeMarker5Length + 1
      }
    });
    polish.noUiSlider.on('update', function (values, handle) {
      var startPoint5 = parseInt(polish.noUiSlider.get()[0]) - 1;
      var endPoint5 = parseInt(polish.noUiSlider.get()[1]) - 2;
      pipeMarker5.removeClass("selected");
      for (var i = startPoint5; i <= endPoint5; i++) {
        pipeMarker5.eq(i).addClass("selected");
      }
    });
  }

  var dropHeight = $('.diamond-search .search-dropdown-inner').innerHeight();
  var tableHeight = $('.diamond-search .result-table').innerHeight();

  $(".filter-btn .reset-btn").on("click", function () {
    price.noUiSlider.reset();
    color.noUiSlider.reset();
    carat.noUiSlider.reset();
    clarity.noUiSlider.reset();
    symmetry.noUiSlider.reset();
    cut.noUiSlider.reset();
    polish.noUiSlider.reset();
  });

  /*03-05-2019*/

  $('.search-dropdown').click(function () {
    $(this).toggleClass('active');
    $(this).closest('.diamondsearch-inner').find('.search-dropdown-inner').stop(true, true).slideToggle();

    /*searchdropdown-height*/

    if ($('.search-dropdown').hasClass('active')) {
      $('.diamond-search .result-table').css('height', dropHeight);
    } else {

      $('.diamond-search .result-table').css('height', "");
    }
  });
  $('.search-dropdown-inner .search-btn').click(function (event) {
    event.preventDefault();
    $(this).closest('.search-dropdown-inner').slideUp();
    $('.search-dropdown').removeClass('active');

    if ($('.search-dropdown').hasClass('active')) {
      $('.diamond-search .result-table').css('height', dropHeight);
    } else {

      $('.diamond-search .result-table').css('height', "");
    }
  });
  $('.search-dropdown-inner .reset-btn').click(function (event) {
    event.preventDefault();
    $(this).closest('.search-dropdown-inner').slideUp();
    $('.search-dropdown').removeClass('active');

    if ($('.search-dropdown').hasClass('active')) {
      $('.diamond-search .result-table').css('height', dropHeight);
    } else {

      $('.diamond-search .result-table').css('height', "");
    }
  });

  $('.diamond-search .ds-filter-shape ul li').click(function () {
    $(this).toggleClass('active');
  });
  $('.diamond-search .fancy-color li').click(function () {
    $(this).toggleClass('active');
  });
  $('.diamond-search .certificate-wrapper li').click(function () {
    $(this).toggleClass('active');
  });

  $(document).on("click", ".diamond-search .btn-block a", function (event) {
    event.preventDefault();
  });
  $(document).on("click", ".detail-modal .close", function (event) {
    event.preventDefault();
    $(this).closest(".detail-modal").hide();
    $("html, body").removeClass("backdrop-overlay modal-open");
  });
  $(document).on("click", ".question-modal .close", function (event) {
    event.preventDefault();
    $(this).closest(".question-modal").hide();
    $(this).closest(".question-modal").prev(".detail-modal").show();
  });



  $('.diamond-search .more-btn').click(function () {
    $('.diamond-search .question-modal').show();
    $('.diamond-search .detail-modal').hide();
  });
  $('.diamond-search .question-modal .close').click(function (e) {
    e.preventDefault();
    $('.diamond-search .question-modal').hide();

    var value = $('#detail-modal-value').val();
    $("#detail-modal-" + value).show();
  });


  $('.diamond-search .color-slider .color').click(function () {
    $(this).addClass('active');
    $('.diamond-search .color-slider .fancy').removeClass('active');
    $('.diamond-search .color-block').addClass('active');
    $('.diamond-search .fancy-block').removeClass('active');

  });

  $('.diamond-search .color-slider .fancy').click(function () {
    $(this).addClass('active');
    $('.diamond-search .color-slider .color').removeClass('active');
    $('.diamond-search .fancy-block').addClass('active');
    $('.diamond-search .color-block').removeClass('active');

  });

  $(".hamburger-icon").click(function () {
    $("html,body").toggleClass("open-menu");
  }), $(".navigation-search").appendTo($(".header-navigation"));
  var e = $.trim($(".header-navigation .search-nav-link a").text());
  $(".search-nav-link a").text(e), $(".header-navigation .search-nav-link a").click(function (e) {
    e.preventDefault(), e.stopImmediatePropagation(), "Search" == $(this).text() ? ($(this).text("Close"),
                                                                                    $(this).closest(".navigation-outer").find(".navigation-search").fadeIn()) : ($(this).text("Search"),
                $(this).closest(".navigation-outer").find(".navigation-search").fadeOut());
  }), $(".header-navigation .navigation-search").click(function (e) {
    e.stopImmediatePropagation();
  }), $("html,body").click(function () {
    $(".header-navigation .search-nav-link a").text("Search");
  }), $(".footer-links .search-nav-link a").click(function (e) {
    e.preventDefault(), e.stopImmediatePropagation(), $("html,body").animate({
      scrollTop: 0
    }, 700, function () {
      $(".header-navigation .search-nav-link a").click();
    });
  }), $("a[href='#']").click(function (e) {
    e.preventDefault();
  });
  -1 != navigator.appVersion.indexOf("Mac") && ($(".button").css("padding-bottom", "5px"),
                                                $(".woo_catalog_enquiry_custom_button_enquiry").css("padding-bottom", "5px"),
                                                $(".submit").css("padding-bottom", "5px"));
}), $.fn.extend({
  equalHeights: function () {
    var e = 0, a = ("equalHeights" + Math.random()).replace(".", "");
    $(this).each(function () {
      var t = $(this).offset().top;
      t > e && ($("." + a).removeClass(a), e = t), $(this).addClass(a), $(this).height("auto");
      var r = Math.max.apply(null, $("." + a).map(function () {
        return $(this).outerHeight();
      }).get());
      $("." + a).height(r);
    }).removeClass(a);
  }
});

$(document).on('change', '.hulkapps_option_value select', function(){
  var fingersizeValuee = $(this).val();
  if(fingersizeValuee != ''){
    $(this).removeClass('select-finger');
  }

});

function addItem(_this) {
  console.log('clicked');
  var $this = $(_this)
  var quantity = $("input[name='quantity']").val();
  var variant_id = $this.attr('data-variantid');
  var hasfingerSize = $('.hulkapps_option_value select').length;
  var fingersizeValue = $('.hulkapps_option_value select').val();
  
  if(hasfingerSize > 0 && fingersizeValue == ''){
   $('.hulkapps_option_value select').addClass('select-finger');
  }else{
    console.log(variant_id+'<<>>'+quantity, $this.closest('[data-section-type="product"]').find('form[action="/cart/add"]'))
//     ?id='+variant_id+'&quantity='+quantity
    $.ajax({
      type: 'POST', 
      url: '/cart/add',
      data: $this.closest('[data-section-type="product"]').find('form[action="/cart/add"]').serialize(),
      dataType: 'json',
      success:function(){
        window.location.reload();
      }

    });
  }
}

$(document).on('click', '.ProductForm__AddToCart', function(e){
  var hasfingerSize = $('.hulkapps_option_value select').length;
  var fingersizeValue = $('.hulkapps_option_value select').val();
  if(hasfingerSize > 0 && fingersizeValue == ''){
    e.preventDefault();
    $('.hulkapps_option_value select').addClass('select-finger');
  }
});